import { jsx as _jsx } from "react/jsx-runtime";
import { Wrap } from '@chakra-ui/react';
import { ImageListItemProvider, useImageList, } from '@client/components/listingForm/imageList/ImageListContext';
import { DndContext, MouseSensor, TouchSensor, closestCenter, useSensor, useSensors, } from '@dnd-kit/core';
import { SortableContext, arrayMove, rectSortingStrategy, } from '@dnd-kit/sortable';
export const ImageGrid = ({ children, ...wrapProps }) => {
    const { entries, reorder, disabled } = useImageList();
    const sensors = useSensors(useSensor(MouseSensor, {
        activationConstraint: { distance: 5 },
    }), useSensor(TouchSensor, {
        activationConstraint: { delay: 150, tolerance: 5 },
    }));
    const handleDragEnd = ({ active, over }) => {
        if (disabled || !over || active.id === over.id)
            return;
        const oldIndex = entries.findIndex((e) => e.previewUrl === active.id);
        const newIndex = entries.findIndex((e) => e.previewUrl === over.id);
        reorder(arrayMove(entries, oldIndex, newIndex));
    };
    return (_jsx(DndContext, { sensors: sensors, collisionDetection: closestCenter, onDragEnd: handleDragEnd, children: _jsx(SortableContext, { items: entries.map((e) => e.previewUrl), strategy: rectSortingStrategy, children: _jsx(Wrap, { alignItems: "flex-start", ...wrapProps, children: entries.map((entry, index) => (_jsx(ImageListItemProvider, { entry: entry, index: index, children: children }, entry.previewUrl))) }) }) }));
};
